import { render, staticRenderFns } from "./PhotoSwipe.vue?vue&type=template&id=27462270&"
import script from "./PhotoSwipe.vue?vue&type=script&lang=js&"
export * from "./PhotoSwipe.vue?vue&type=script&lang=js&"
import style0 from "photoswipe/dist/photoswipe.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "photoswipe/dist/default-skin/default-skin.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports